module.exports = __webpack_public_path__ + "img/03-4.a3814dc5.png";